import React from 'react';
import {NotFound as Layout} from 'app/layouts/NotFound';

export class NotFound extends React.Component<Props> {

	render() {
		return (
			<Layout />
		);
	}
}